import React from 'react';

import { AdminBrokersTable } from 'src/components';

import classes from './adminImpersonate.module.scss';

export const AdminImpersonate = () => {
  return (
    <div className={classes.AdminImpersonate}>
      <AdminBrokersTable />
    </div>
  );
};
